import {
  Grid,
  Link,
  Stack,
  Typography
  } from "@mui/material";

export function SignUpFormFooter() {
  return (
    <Grid container spacing={2} direction="column">
      <Grid item xs={12}>
        <Stack spacing={1} direction="row" justifyContent="center">
          <Typography fontSize={14}>Masz już konto? </Typography>
          <Link href="/" underline="hover" fontSize={14}>
            Zaloguj się!
          </Link>
        </Stack>
      </Grid>
      <Grid item xs={12}>
        <Stack spacing={1} direction="row" justifyContent="center">
          <Typography fontSize={14}>Nie pamiętasz hasła? </Typography>
          <Link href="/resetPassword" underline="hover" fontSize={14}>
            Zresetuj hasło
          </Link>
        </Stack>
      </Grid>
    </Grid>
  );
}

export function SignInFormFooter() {
  return (
    <Grid container spacing={2} direction="row" alignItems="center" sx={{ width: "100%" }}>
      <Grid item xs={6} sx={{ textAlign: "center" }}>
        <Link href="/resetPassword" underline="hover" variant="subtitle2">
          Zresetuj hasło
        </Link>
      </Grid>
      <Grid item xs={6} sx={{ textAlign: "center" }}>
        <Link href="/sign-up" underline="hover" variant="subtitle2">
          Utwórz konto
        </Link>
      </Grid>
    </Grid>
  );
}
